
import { AnswerModalButton, AnswerModalContainer, AnswerModalContent, AnswerModalText, AnswerModalTexts, AnswerModalTitle } from "./styles";

type AnswerModalProps = {
  username: string;
  text: string;
  onClick: () => void;
}

export default function AnswerModal({ username, text, onClick }: AnswerModalProps) {
  return (
    <AnswerModalContainer>
      <AnswerModalContent>
        <AnswerModalTexts>
          <AnswerModalTitle>Respondendo à <strong>{username}</strong></AnswerModalTitle>
          <AnswerModalText>{text.substring(0, 100)} {text.length > 100 && '...'}</AnswerModalText>
        </AnswerModalTexts>
        <AnswerModalButton onClick={onClick}><Close /></AnswerModalButton>
      </AnswerModalContent>
    </AnswerModalContainer>
  );
}

function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <path
        stroke="#000"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.333"
        d="M12 4.072l-8 8M4 4.072l8 8"
      ></path>
    </svg>
  );
}
